import { ParsedUrlQuery } from 'querystring';

export const getQueryKeyValue = (queryObject: ParsedUrlQuery, key: string) => {
  const queryValue = queryObject[key];

  return queryValue == null ? '' : Array.isArray(queryValue) ? `${key}=${queryValue[0]}` : `${key}=${queryValue}`;
};
